import { ShareActionTypes, SETINVITECODE } from './actionTypes';

export function setInviteCode(shareCode: string): ShareActionTypes {
  return { type: SETINVITECODE, shareCode };
}
